import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import { COMPANY_INFO, FOOTER_LINKS, SOCIAL_LINKS } from '../utils/constants';

const Footer = () => {
  const socialIconMap = {
    Linkedin: FaLinkedin,
    Instagram: FaInstagram,
    Youtube: FaYoutube,
  };

  const handleLinkClick = (path) => {
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer style={{ backgroundColor: '#111111', color: '#FFFFFF' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '5rem 1.5rem 0' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '3rem',
        }} className="footer-grid">
          {/* Brand Column */}
          <div>
            <Link
              to="/"
              style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '1rem' }}
            >
              <span style={{
                fontFamily: '"DM Sans", sans-serif',
                fontWeight: 700,
                fontSize: '1.5rem',
                color: '#FFFFFF',
                letterSpacing: '-0.02em',
              }}>
                Rishant
              </span>
              <span style={{
                fontFamily: '"DM Sans", sans-serif',
                fontWeight: 500,
                fontSize: '0.95rem',
                color: 'rgba(255,255,255,0.5)',
              }}>
                Technologies
              </span>
            </Link>
            <p style={{
              fontSize: '0.9rem',
              lineHeight: 1.65,
              color: 'rgba(255,255,255,0.4)',
              maxWidth: '280px',
              marginTop: '1rem',
              fontFamily: '"DM Sans", sans-serif',
            }}>
              {COMPANY_INFO.tagline}
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h4 style={{
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: 'rgba(255,255,255,0.3)',
              marginBottom: '1.25rem',
              fontFamily: '"DM Sans", sans-serif',
            }}>
              Services
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {FOOTER_LINKS.services.map((link) => (
                <li key={link.name} style={{ marginBottom: '0.75rem' }}>
                  <Link
                    to={link.path}
                    onClick={() => handleLinkClick(link.path)}
                    style={{
                      color: 'rgba(255,255,255,0.5)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      transition: 'color 0.15s',
                      fontFamily: '"DM Sans", sans-serif',
                    }}
                    onMouseEnter={e => e.target.style.color = '#FFFFFF'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 style={{
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: 'rgba(255,255,255,0.3)',
              marginBottom: '1.25rem',
              fontFamily: '"DM Sans", sans-serif',
            }}>
              Company
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {FOOTER_LINKS.company.map((link) => (
                <li key={link.name} style={{ marginBottom: '0.75rem' }}>
                  {link.path.startsWith('#') ? (
                    <button
                      onClick={() => handleLinkClick(link.path)}
                      style={{
                        color: 'rgba(255,255,255,0.5)',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                        transition: 'color 0.15s',
                        fontFamily: '"DM Sans", sans-serif',
                        textAlign: 'left',
                      }}
                      onMouseEnter={e => e.target.style.color = '#FFFFFF'}
                      onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
                    >
                      {link.name}
                    </button>
                  ) : (
                    <Link
                      to={link.path}
                      style={{
                        color: 'rgba(255,255,255,0.5)',
                        textDecoration: 'none',
                        fontSize: '0.9rem',
                        transition: 'color 0.15s',
                        fontFamily: '"DM Sans", sans-serif',
                      }}
                      onMouseEnter={e => e.target.style.color = '#FFFFFF'}
                      onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 style={{
              fontSize: '0.75rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: 'rgba(255,255,255,0.3)',
              marginBottom: '1.25rem',
              fontFamily: '"DM Sans", sans-serif',
            }}>
              Get in Touch
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '0.75rem' }}>
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  style={{
                    color: 'rgba(255,255,255,0.5)',
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    transition: 'color 0.15s',
                    fontFamily: '"DM Sans", sans-serif',
                  }}
                  onMouseEnter={e => e.target.style.color = '#FFFFFF'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
                >
                  {COMPANY_INFO.email}
                </a>
              </li>
              <li style={{ marginBottom: '0.75rem' }}>
                <a
                  href={COMPANY_INFO.whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: 'rgba(255,255,255,0.5)',
                    textDecoration: 'none',
                    fontSize: '0.9rem',
                    transition: 'color 0.15s',
                    fontFamily: '"DM Sans", sans-serif',
                  }}
                  onMouseEnter={e => e.target.style.color = '#FFFFFF'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
                >
                  WhatsApp
                </a>
              </li>
            </ul>
            {/* Social Links */}
            <div style={{ display: 'flex', gap: '12px', marginTop: '1rem' }}>
              {SOCIAL_LINKS.map((social) => {
                const IconComponent = socialIconMap[social.icon];
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: 'rgba(255,255,255,0.3)',
                      transition: 'color 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = '#FFFFFF'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}
                    aria-label={social.name}
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.08)',
          marginTop: '3.5rem',
          padding: '1.5rem 0',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
        }}>
          <p style={{
            fontSize: '0.8rem',
            color: 'rgba(255,255,255,0.25)',
            fontFamily: '"DM Sans", sans-serif',
          }}>
            &copy; {new Date().getFullYear()} {COMPANY_INFO.fullName}. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
            <Link
              to="/privacy"
              style={{
                fontSize: '0.8rem',
                color: 'rgba(255,255,255,0.25)',
                textDecoration: 'none',
                fontFamily: '"DM Sans", sans-serif',
                transition: 'color 0.15s',
              }}
              onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              style={{
                fontSize: '0.8rem',
                color: 'rgba(255,255,255,0.25)',
                textDecoration: 'none',
                fontFamily: '"DM Sans", sans-serif',
                transition: 'color 0.15s',
              }}
              onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.25)'}
            >
              Terms of Service
            </Link>
            <span style={{
              fontSize: '0.8rem',
              color: 'rgba(255,255,255,0.25)',
              fontFamily: '"DM Sans", sans-serif',
            }}>
              Made in India
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .footer-grid {
            grid-template-columns: 1.5fr 1fr 1fr 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
